import { PayloadAction } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';
import { call, put } from 'redux-saga/effects';

import { rikHttpClient } from 'services/httpClient';
import IEditInterventionRequestBody from 'services/httpClient/requests/intervention/IEditInterventionRequestBody';
import IEditInterventionResponse from 'services/httpClient/responses/intervention/IEditInterventionResponse';

import { interventionActions } from '../index';
import { IEditInterventionRequestAction } from '../reducers/edit/request';

function* edit(action: PayloadAction<IEditInterventionRequestAction>) {
  try {
    const body: IEditInterventionRequestBody = {
      no_repair: action.payload.data.noRepair?.toString(),
      category_id: action.payload.data.categoryId || undefined,
      first_visit_date: action.payload.data.firstVisitDate || undefined,
      intervention_type: action.payload.data.interventionType || undefined,
      invoice_number: action.payload.data.invoiceNumber || undefined,
      invoice_value_cents: action.payload.data.invoiceValueCents || undefined,
      price_excl_vat: action.payload.data.priceExclVat || undefined,
      quote_approved: action.payload.data.quoteApproved || undefined,
      quote_value_cents: action.payload.data.quoteValueCents || undefined,
      repair_date: action.payload.data.repairDate || undefined,
      repair_end_date: action.payload.data.repairEndDate || undefined,
      status: action.payload.data.status || undefined,
      vat_percentage: action.payload.data.vatPercentage || undefined,
    };

    const response: AxiosResponse<IEditInterventionResponse> = yield call(
      rikHttpClient.put,
      `interventions/${action.payload.data.id}`,
      body,
    );

    yield put(
      interventionActions.editSuccess({
        intervention: response.data,
      }),
    );

    if (action.payload.functions.success) {
      action.payload.functions.success();
    }
  } catch (err: any) {
    action.payload.functions.error(err);

    yield put(interventionActions.editFailure());
  }
}

export default edit;
